import request from './request';

const locationInformation = {
	async getLocationBuildingFloorsById(options) {
		const response = await request.get('/app/locations/building-floors', options);
		return response;
	}
};

export default locationInformation;